import { render, staticRenderFns } from "./ProductBadgeLabelCreateForm.vue?vue&type=template&id=4af2548b&scoped=true&"
import script from "./ProductBadgeLabelCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProductBadgeLabelCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductBadgeLabelCreateForm.vue?vue&type=style&index=0&id=4af2548b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2548b",
  null
  
)

export default component.exports